<template>
  <div v-loading="loading">
    <draggerBox
      :menuList="menuList"
      @save="onSave"
      :loading="saveLoading"
      :type="2"
      :buttonName="btnName"
      :auth="auth"
    ></draggerBox>
  </div>
</template>
<script>
import { getDicByCode, postUpdateDicByCode } from '@/server/common'
import draggerBox from '../components/dragger'
export default {
  name: 'service-category',
  components: {
    draggerBox
  },
  computed: {
    btnName() {
      return this.$t('after-sales::after-sales-set::refund_type_add')
    }
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      menuList: [],
      auth: 'after-sales::after-sales-set::refund-'
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    async getListData() {
      this.loading = true
      const { data } = await getDicByCode(2)
      console.log(data)
      this.loading = false
      if (data.code === this.$code) {
        this.menuList = data.data.map((item, i) => {
          return {
            ...item,
            name: this.$t(`system::refund::type::${item.name}`, item.name)
          }
        })
      }
    },
    async onSave(items) {
      this.saveLoading = true
      const { data } = await postUpdateDicByCode({
        type: 2,
        items: items
          .filter(el => el.merchantId !== 0)
          .map((item, index) => {
            return {
              ...item,
              sequence: index
            }
          })
      })
      this.saveLoading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.getListData()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
